import { createStore } from "solid-js/store";

import { LocalStorageKey } from "@/constants/constants";
import { LoginTypeEnum } from "@/enum/loginRegister";
import { t } from "@/i18n";
import { getLocalStorageItem, setLocalStorageItem } from "@/lib/localStorage";

interface LoginStore {
  //tab栏
  tabList: {
    label: string;
    value: string;
  }[];
  //选中tab
  tabActive: string;
}

const initialLoginStore: LoginStore = {
  tabList: [],
  tabActive: LoginTypeEnum.cpf,
};

export const [loginStore, setLoginStore] = createStore<LoginStore>(
  JSON.parse(JSON.stringify(initialLoginStore)),
);

export const setTabList = () => {
  const tabList = [
    {
      label: t("withdraw.cpf"),
      value: LoginTypeEnum.cpf,
    },
    {
      label: t("auth.email"),
      value: LoginTypeEnum.email,
    },
    {
      label: t("auth.phone"),
      value: LoginTypeEnum.phone,
    },
  ];
  setLoginStore("tabList", tabList);
};
// 切换选中tab
export const changeTabActive = (val?: string) => {
  if (val === loginStore.tabActive) return;
  let tabActive = "";
  if (val) {
    tabActive = val;
  } else {
    tabActive =
      getLocalStorageItem(LocalStorageKey.LOGIN_TYPE, LoginTypeEnum.cpf) ||
      LoginTypeEnum.phone;
  }
  setLocalStorageItem(LocalStorageKey.LOGIN_TYPE, tabActive);
  setLoginStore("tabActive", String(tabActive));
};
// 初始化
export const initLoginStore = () => {
  setTabList();
  changeTabActive();
};
